import { hexToRgb } from '../../../../models/utils/colorUtils';
import { grayDark, green, hotPink, kitTintColor, lightBlue, yellow } from '../../../styles/colors';

type CategoryHue = 'gray' | 'green' | 'pink' | 'orange' | 'blue' | 'yellow';

interface ICategorySwatch {
	hex: string;
	hue: CategoryHue;
	label: string;
}

export const CATEGORY_SWATCHES: readonly ICategorySwatch[] = [
	{ hex: grayDark, hue: 'gray', label: 'Gray' },
	{ hex: green, hue: 'green', label: 'Green' },
	{ hex: hotPink, hue: 'pink', label: 'Pink' },
	{ hex: kitTintColor, hue: 'orange', label: 'Orange' },
	{ hex: lightBlue, hue: 'blue', label: 'Blue' },
	{ hex: yellow, hue: 'yellow', label: 'Yellow' },
];

/** Pill colors are named hues, so a stored hex maps to the nearest swatch hue. */
export const nearestHue = (hex: string): CategoryHue => {
	const target = hexToRgb(hex);
	if (!target) {
		return 'pink';
	}
	let best: ICategorySwatch = CATEGORY_SWATCHES[0];
	let bestDistance = Number.POSITIVE_INFINITY;
	for (const swatch of CATEGORY_SWATCHES) {
		const rgb = hexToRgb(swatch.hex);
		const distance = (rgb.r - target.r) ** 2 + (rgb.g - target.g) ** 2 + (rgb.b - target.b) ** 2;
		if (distance < bestDistance) {
			bestDistance = distance;
			best = swatch;
		}
	}
	return best.hue;
};
